<template>
  <Navbar />
  <!-- Hero Area -->

  <div id="home" class="homepage-slides">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="30"
      navigation
      :pagination="{ clickable: true }"
      :autoplay="{ delay: 4000 }"
    >
      <swiper-slide>
        <div class="single-slide-item hero-area-bg-5">
          <div class="overlay"></div>
          <div class="hero-area-content">
            <div class="container">
              <div class="row justify-content-center">
                <div
                  class="col-lg-8 col-md-10 col-11 text-center wow fadeInUp animated"
                  data-wow-delay=".2s"
                >
                  <div class="section-title">
                    <h6>Doświadczenie od 1992 roku</h6>
                    <h1>Wiesława Ciborowska<b><br>biegły rewident</b></h1>
                    <p>
                      Kompleksowe usługi księgowe oraz audytorskie na najwyższym poziomie – rzetelność, zgodność z przepisami i pełne wsparcie merytoryczne.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>

  <!-- Promo Area -->

  <div class="promo-area">
    <div class="container">
      <div class="row gx-0">
        <div class="col-lg-4 col-12">
          <div class="single-promo-item mb-50">
            <div class="promo-icon">
              <i class="flaticon-lawyer"></i>
            </div>
            <h5>Wykwalifikowany biegły</h5>
            <p>
              Uprawniony biegły rewident z wieloletnim doświadczeniem w pracy <br>Nr legitymacji: 501
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12">
          <div class="single-promo-item mb-50 spro">
            <div class="promo-icon">
              <i class="flaticon-balance"></i>
            </div>
            <h5>Uczciwość i przejrzystość</h5>
            <p>
              Wszystkie usługi świadczone są w pełnej zgodności
              z obowiązującymi przepisami prawa oraz standardami rewizji finansowej.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12">
          <div class="single-promo-item mb-50">
            <div class="promo-icon">
              <i class="flaticon-podium"></i>
            </div>
            <h5>Gwarancja udanej współpracy</h5>
            <p>
              Otwarta komunikacja, terminowość i indywidualne podejście
              – dzięki temu współpraca przebiega sprawnie i efektywnie.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- About Us Area-->

  <div id="about" class="about-area bg-cover section-padding">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-md-12 wow fadeInLeft" data-wow-delay=".3s">
          <div class="about-content-area">
            <div class="section-title">
              <h6>Więcej informacji
              </h6>
              <h2>
                Ponad 30 lat świadczonych usług księgowych oraz audytorskich jako uprawniony
                <b>biegły rewident</b>
              </h2>
            </div>
            <p>
              Od ponad trzech dekad wspieram przedsiębiorstwa, instytucje i organizacje w zakresie
              rzetelnego audytu finansowego. Dzięki zdobytemu doświadczeniu oferuję
              usługi na najwyższym poziomie, zgodne z aktualnymi przepisami i standardami branżowymi.
              Moja praca opiera się na dokładności, poufności i niezależnym podejściu.
              Klienci cenią mnie za solidność, przejrzystość działania oraz gotowość do wyjaśniania
              złożonych kwestii w prosty sposób. Rozumiem realia biznesu i dostosowuję się do potrzeb każdego klienta.
              Zapraszam do kontaktu i skorzystania z profesjonalnego wsparcia.
            </p>
            <ul class="about-key mt-30">
              <li>
                <i class="las la-check-square"></i>
                <p>Wysoki profesjonalizm</p>
              </li>
              <li>
                <i class="las la-check-square"></i>
                <p>30+ lat doświadczenia</p>
              </li>
              <li>
                <i class="las la-check-square"></i>
                <p>Rzetelność wykonywanych usług</p>
              </li>
              <li>
                <i class="las la-check-square"></i>
                <p>Wielu zadowolonych klientów</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 wow fadeInRight" data-wow-delay=".4s">
          <div class="about-bg">
            <img src="assets/img/about/about.jpeg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Service Area -->

  <div id="service" class="serv-area sky-bg section-padding">
    <div class="container">
      <div class="row">
        <div class="offset-lg-2 col-lg-8 text-center">
          <div class="section-title">
            <h6>Zakres działalności</h6>
            <h2>Audyt<br /><b>sprawozdań finansowych</b></h2>
            <p>
              Przeprowadzane usługi rewizji finansowej są zgodne z obowiązującymi
              zasadami badania wynikającymi z Krajowych Standardów Badania
              w brzmieniu Międzynarodowych Standardów Badania.
              Biuro wpisane jest na listę firm audytorskich pod numerem 4160,
              tym samym uprawnione jest do świadczenia usług w zakresie:
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-lg-6 col-md-6 col-sm-12 wow fadeInLeft"
          data-wow-delay=".2s"
          v-for="service in services.slice(0, 4)"
          :key="service.id"
        >
          <div class="single-serv-wrapper">
            <div class="row gx-0">
              <div class="col-lg-6">
                <div
                  class="single-serv-bg bg-cover"
                  :style="
                    'background-image:url(' + service.images.banner_image + ')'
                  "
                ></div>
              </div>
              <div class="col-lg-6">
                <div class="single-serv-area">
                  <div class="service-icon">
                    <i :class="service.icon"></i>
                  </div>
                  <h5>{{ service.name }}</h5>
                  <p>{{ service.short_description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contact Section -->

  <div id="contact" class="contact-section bg-cover section-padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-12 wow fadeInLeft">
          <div class="contact-info">
            <div class="section-title">
              <h6>Kontakt</h6>
              <h2>Skontaktuj się <b>ze mną</b></h2>
            </div>
            <p>
              Masz pytania lub potrzebujesz fachowej porady?
              Chętnie odpowiem i omówię szczegóły potencjalnej współpracy.
              Zapraszam do kontaktu telefonicznego, mailowego lub przez formularz dostępny na stronie.
            </p>
            <div class="contact-content">
              <div class="contact-inner">
                <i class="las la-map-marker"></i>
                <h6>Adres</h6>
                <p>{{ contact.address }}</p>
              </div>
              <div class="contact-inner">
                <i class="las la-envelope"></i>
                <h6>E-mail</h6>
                <p>{{ contact.mail }}</p>
              </div>
              <div class="contact-inner">
                <i class="las la-phone"></i>
                <h6>Nr telefonu</h6>
                <p>{{ contact.phone }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12 wow fadeInRight">
          <div class="contact-form">
            <form action="/">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                  <input type="text" placeholder="Imię i nazwisko" />
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <input type="email" placeholder="E-mail" />
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <input type="tel" placeholder="Numer telefonu" />
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <input type="text" placeholder="Temat" />
                </div>
                <div class="col-lg-12">
                  <textarea
                    name="message"
                    id="message"
                    cols="30"
                    rows="10"
                    placeholder="Napisz wiadomość"
                  ></textarea>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <button class="main-btn">Wyślij</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer />
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination, A11y, Autoplay } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import axios from "axios";

export default {
  name: "Home",
  components: { Navbar, Swiper, SwiperSlide, Footer },
  data() {
    return {
      modules: [Navigation, Pagination, A11y, Autoplay],
      contact: [],
      services: [],
    };
  },

  async mounted() {
    //scrolling to top of the window
    window.scrollTo(0, 0);

    let fetchedContactData = await axios.get("/assets/data/homeData.json");
    this.contact = fetchedContactData.data.homeData;

    let fetcheServicesdData = await axios.get("/assets/data/services.json");
    this.services = fetcheServicesdData.data.services;
  },
};
</script>
<script setup>
import { useSeoMeta } from "@vueuse/head";
useSeoMeta({
  title: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
  description: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
  ogDescription: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
  ogTitle: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
});
</script>
